import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { combineLatest, map } from 'rxjs';
import { SubHeaderService } from '../services/subheader.service';
import { BackButtonDirective } from '../../shared/directives/back-button.directive';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'uw-subheader',
    templateUrl: './subheader.component.html',
    styleUrls: ['./subheader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BackButtonDirective, TranslateModule]
})
export class SubheaderComponent {
  private readonly _subHeaderService = inject(SubHeaderService);

  protected readonly vm = toSignal(
    combineLatest([
      this._subHeaderService.title$,
      this._subHeaderService.subTitle$,
      this._subHeaderService.badge$
    ]).pipe(
      map(([title, subTitle, badge]) => ({ title, subTitle, badge: badge ?? '' }))
    ),
    { initialValue: { title: '', subTitle: '', badge: '' } }
  );
}
